import { PaginationForm } from "@/common/mixins/pagination";
export enum ErrorTrackingStatus {
  WAIT = "wait",
  FIXING = "fixing",
  FIXED = "fixed"
}

export interface ErrorTrackingIncorrectInventoryForm extends PaginationForm {
  status: ErrorTrackingStatus | undefined;
}
